<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn label="Tilbakestill kartutsnitt"
              aria-label="Tilbakestill kartutsnitt" data-v-step="6" small v-on="on" fab @click="resetExtent">
        <v-icon>mdi-arrow-expand-all</v-icon>
      </v-btn>
    </template>
    <span>Tilbakestill kartutsnitt</span>
  </v-tooltip>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "MapResetExtentButton",
  computed: {
    ...mapState(["defaultExtent", "is3d"])
  },
  methods: {
    ...mapActions(["setCurrentOrientation"]),
    resetExtent() {
      if (this.is3d) {
        this.$theSceneViewObject.extent = this.defaultExtent;
      } else {
        this.$theMapViewObject.extent = this.defaultExtent;
      }

      this.setCurrentOrientation(0.0);
      this.$theMapViewObject.rotation = 0.0;
    }
  }
};
</script>

<style></style>
